// inspired by https://dev.to/9zemian5/sync-height-between-elements-in-react-1fg0
import { MutableRefObject, useLayoutEffect } from "react";

type Target = MutableRefObject<HTMLElement | null>;

const store: Record<string, Target[]> = {};
const handleResize = (key: string) => {
    // get all elements with the same key
    const elements = store[key];
    if (elements) {
        let max = 0;
        // find the element with highest clientWidth value
        elements.forEach((element) => {
            if (element.current && element.current.clientWidth > max) {
                max = element.current.clientWidth;
            }
        });
        // update width of all 'joined' elements
        elements.forEach((element) => {
            if (element.current) {
                element.current.style.minWidth = `${max}px`;
            }
        });
    }
};

// Add element to the store when component is mounted and return cleanup function
const add = (key: string, element: Target) => {
    // create store if missing
    if (!store[key]) {
        store[key] = [];
    }

    store[key].push(element);

    // cleanup function
    return () => {
        const index = store[key].indexOf(element);
        if (index > -1) {
            store[key].splice(index, 1);
        }
    };
};

export type UseSyncRefWidthProps = Array<[string, Target]>;
export const useSyncRefWidth = (refs: UseSyncRefWidthProps, deps?: any[]) => {
    useLayoutEffect(() => {
        // store cleanup functions for each entry
        const cleanups: (() => void)[] = [];
        refs.forEach(([key, element]) => {
            // add element ref to store
            cleanups.push(add(key, element));
        });
        return () => {
            // cleanup when component is destroyed
            cleanups.forEach((cleanup) => cleanup());
        };
    }, []);


    useLayoutEffect(() => {
        // when any of the dependencies changes, update all elements heights
        refs.forEach(([key]) => {
            handleResize(key);
        });
    }, deps);
};
